
import UserAgentService from './UserAgentService'

export enum ECallbackType {
  tokenExpired = 'tokenExpired',
  logout = 'logout',
  setTitle = 'setTitle',
  changeCurrentTitle = 'changeCurrentTitle',
  didUpdateUserData = 'didUpdateUserData',
  shouldGoBack = 'shouldGoBack',
  forceBack = 'forceBack',
  endLoading = 'endLoading',
  startLoading = 'startLoading',
  quizzDone = 'quizzDone',
  quizzStart = 'quizzStart',
  quizzCloseSchedule = 'quizzCloseSchedule',
  needsWifiChange = 'needsWifiChange',
  needsHomekitInstall = 'needsHomekitInstall',
  needsHomekitConfigure = 'needsHomekitConfigure',
  needsNewModule = 'needsNewModule',
  needsNewInstall = 'needsNewInstall',
  shouldExit = 'shouldExit',
  shareIt = 'shareIt',
  canShare = 'canShare',
  openInBrowser = 'openInBrowser',
  download = 'download',
  updateFirmware = 'updateFirmware',
  onPageLoaded = 'onPageLoaded',
  enableBack = 'enableBack',
  enableClose = 'enableClose'
}

class Callback {
  private userAgent: UserAgentService

  constructor () {
    this.userAgent = new UserAgentService(navigator.userAgent)
  }

  call (name: ECallbackType, args = null) {
    if (this.userAgent.isNativeApp()) {
      // For native app
      let iframe = document.createElement('IFRAME') as HTMLElement | null
      if (iframe !== null) {
        iframe.setAttribute('src', 'js-frame:' + name + ':0:' + encodeURIComponent(JSON.stringify(args)))
        document.documentElement.appendChild(iframe)
        if (iframe.parentNode !== null) {
          iframe.parentNode.removeChild(iframe)
        }
        iframe = null
      }
    } else {
      // Send message callback to parent which hosted iframe
      const msg = { id: name, params: args }
      window.parent.postMessage(msg, '*')
    }
  }
}

export default Callback
